module.exports = ".row{\r\n    padding:14px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/emp-salary-details/variable-allowance/variable-allowance-form/variable-allowance-form.component.css
// module id = ./src/app/hrms/payroll/emp-salary-details/variable-allowance/variable-allowance-form/variable-allowance-form.component.css
// module chunks = main